import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  generateNewObjectByHours(object: any, hours: number): any {
    const timestamp = this.generateTimestampByHours(hours);
    return {
      ...object,
      save_cache_until_timestamp: timestamp,
      save_cache_until_date: new Date(timestamp)?.toString(),
    }
  }

  generateTimestampByHours(hours: number): number {
    if(!hours) return new Date().getTime();

    const millisecondsPerHour = 3600000;
    return new Date().getTime() + (hours * millisecondsPerHour);
  }

  isExpiredCache(object: any): boolean {
    if(!object?.save_cache_until_timestamp) return true;

    return object?.save_cache_until_timestamp < new Date().getTime();
  }
}
